import { ThemeEvents } from '@theme/events';

/**
 * A custom element that wraps the "New Color" label rendered above the product
 * title. The label's visibility/text is computed server-side in Liquid (by
 * comparing the `custom.new_colors` metafield to the currently selected
 * variant's color), so on a plain page load it's already correct. This
 * listens for variant-update events so it also stays correct after the
 * customer switches to a different color client-side, without a full page
 * reload (native Color option products; combined-listing color swaps already
 * navigate to a new product URL and re-render everything).
 */
class NewColorBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * @param {CustomEvent} event - The variant update event.
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector('new-color-badge');
    if (!newBadge) return;

    if (this.innerHTML !== newBadge.innerHTML) {
      this.innerHTML = newBadge.innerHTML;
    }
  };
}

if (!customElements.get('new-color-badge')) {
  customElements.define('new-color-badge', NewColorBadge);
}
